import { render, staticRenderFns } from "./BotaoVisualizar.vue?vue&type=template&id=575a8d00"
import script from "./BotaoVisualizar.vue?vue&type=script&lang=js"
export * from "./BotaoVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports